import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/licenses/new',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/LicenseNewContainer',
      './modules/LicenseNew'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const LicenseNew = require('./containers/LicenseNewContainer').default
      const actions = require('./modules/LicenseNew')
      const reducer = require('./modules/LicenseNew').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'licenseNew', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, LicenseNew)

    /* Webpack named bundle   */
    }, 'LicenseNew')
  }
})



// WEBPACK FOOTER //
// ./src/routes/LicenseNew/index.js